module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-alert",
    class: {
      'uk-alert-success': _vm.color == 'success',
        'uk-alert-warning': _vm.color == 'warning',
        'uk-alert-danger': _vm.color == 'danger',
        'uk-alert-large': _vm.large
    },
    attrs: {
      "data-uk-alert": ""
    }
  }, [(_vm.closable) ? _c('a', {
    staticClass: "uk-alert-close uk-close",
    attrs: {
      "href": ""
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ff3a3118!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UkAlert.vue
// module id = 305
// module chunks = 2